module.exports = __webpack_public_path__ + "img/meetcard-white.398a8cab.svg";